import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppWithTheme from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppWithTheme />
  </React.StrictMode>,
);
